module.exports = __webpack_public_path__ + "fonts/proximanovasoft-regular-webfont.8d42f61.ttf";